import { code } from "@spscommerce/utils";

export const SpsToggleExamples = {
    small: {
        label: "Small",
        description: "info about small toggle buttons",
        examples: {
            small: {
                template: code`
                    <form [formGroup]="form">
                        <sps-toggle id="small-toggle" formControlName="smallToggle"></sps-toggle>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                smallToggle: []
                            })
                        }
                    }
                `
            }
        }
    },
    large: {
        label: "Large",
        description: "info about large toggle buttons",
        examples: {
            large: {
                template: code`
                    <form [formGroup]="form">
                        <sps-toggle large formControlName="bigToggle"></sps-toggle>
                    </form>
                `,
                class: code`
                   class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                bigToggle: []
                            })
                        }
                    }
                `
            }
        }
    },
    statusLabel: {
        label: "Status Label",
        description: "toggles with status labels",
        examples: {
            label: {
                template: code`
                    <form [formGroup]="form">
                        <sps-toggle formControlName="toggleWithText"
                            [statusLabel]="['Inactive', 'Active']"> description="Description"
                        </sps-toggle>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                toggleWithText: []
                            })
                        }
                    }
                `
            }
        }
    },
    disabled: {
        label: "Disabled",
        description: "info about disabled toggles",
        examples: {
            disabled: {
                template: code`
                    <form [formGroup]="form">
                        <sps-toggle id="disabled-toggle" formControlName="disabledToggle"
                            [statusLabel]="['Inactive', 'Active']" description="Description">
                        </sps-toggle>
                    </form>
                `,
                class: code`
                  class DemoComponent implements OnInit {
                        constructor(private _formBuilder: FormBuilder) {}
                        form: FormGroup;
                        ngOnInit() {
                            this.form = this._formBuilder.group({
                                disabledToggle: [{value: false, disabled: true}]
                            })
                        }
                    }
                `
            }
        }
    }
};
